import { render, staticRenderFns } from "./PatchwerkComponent.vue?vue&type=template&id=55398ee5&"
import script from "./PatchwerkComponent.vue?vue&type=script&lang=js&"
export * from "./PatchwerkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports